exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-timezone-box[data-v-07865e60]{margin-top:5px;padding:5px 10px;color:#6e7275;background-color:#eee;border-radius:4px;border:1px solid #e6e6e6}.vc-timezone-box span[data-v-07865e60]{font-size:12px;line-height:1.4}", ""]);

// exports
